import { render } from "./ExperimentCard.vue?vue&type=template&id=517f76d4&scoped=true"
import script from "./ExperimentCard.vue?vue&type=script&lang=js"
export * from "./ExperimentCard.vue?vue&type=script&lang=js"

import "./ExperimentCard.vue?vue&type=style&index=0&id=517f76d4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517f76d4"]])

export default __exports__